export default __webpack_public_path__ + "static/media/name-card-green.0f6d491d.svg";